export const CONSTANTS = {
  TIPO_MENU: {
    SCROLL: '#',
    NOVA_PAGINA: '/'
  },
  TIPO_COMPONENTE: {
    MENU: 'menu',
    SESSAO: 'sessao',
    CARROSSEL: 'carrossel',
    CONTATO: 'contato',
    GALERIA: 'galeria'
  },
  POSICAO_LOGO: {
    ESQUERDA: 'Esquerda',
    DIREITA: 'Direita',
    CENTRO: 'Centro'
  },
  LAYOUT_SESSAO: {
    IMG_ESQ: 'Imagem à esqueda',
    IMG_DIR: 'Imagem à direita',
    IMG_BG: 'Imagem de fundo',
    APENAS_TEXTO: 'Apenas texto'
  },
  TIPO_BOTAO: {
    LINK_INTERNO: 'Link interno',
    LINK_EXTERNO: 'Link externo'
  },
  ALINHAMENTO: {
    ESQUERDA: 'left',
    DIREITA: 'right',
    CENTRO: 'center',
    JUSTIFICADO: 'justify'
  },
};
